var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Operation.Operation")))
    ]),
    _vm._v(" "),
    _c("span", {
      staticClass: "mt-0",
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("SummaryReport.Operation.Operation_Instructions_Long")
        )
      }
    }),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Operation.Contents")))
    ]),
    _vm._v(" "),
    _c("span", {
      staticClass: "mt-0",
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("SummaryReport.Operation.Contents_Instructions_Long")
        )
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }